import { logUsage } from 'owa-analytics';
import { createLazyOrchestrator } from 'owa-bundling';
import { changeCalendarViewType } from 'owa-calendar-module-commanding';
import { getNumDaysInDayRange, resetNumDaysInDayRange } from 'owa-calendar-surface-options-utils';
import { processDateRangeTypeOrDayRangeChange } from 'owa-calendar-surface-view-store';
import { CalendarViewTypeEnum, CalendarViewTypeEnumToDateRangeType } from 'owa-calendar-view-type';
import {
    getSelectedViewType,
    updateSelectedViewType,
    SelectedViewTypeSource,
} from 'owa-calendar-module-store';

export const changeCalendarViewTypeOrchestrator = createLazyOrchestrator(
    changeCalendarViewType,
    'changeCalendarViewType_CLONE',
    actionMessage => {
        const { newCalendarViewType, newNumOfDaysInDayRange } = actionMessage;

        if (
            getSelectedViewType() !== CalendarViewTypeEnum.Daily &&
            newCalendarViewType === CalendarViewTypeEnum.Daily
        ) {
            logUsage('switchToSingleDayView', { numberOfDays: newNumOfDaysInDayRange });
        }

        updateSelectedViewType(newCalendarViewType, SelectedViewTypeSource.UserChange);
        processDateRangeTypeOrDayRangeChange(
            CalendarViewTypeEnumToDateRangeType(newCalendarViewType),
            newNumOfDaysInDayRange
        );

        if (newCalendarViewType !== CalendarViewTypeEnum.Daily && getNumDaysInDayRange() > 1) {
            resetNumDaysInDayRange();
        }

        // TODO Handle saved view
    }
);
